import React from 'react';

const Footer: React.FC = () => {
  return <div className="footer-spacer" />;
};

export default Footer;